/**
 * @Description This is FasatMessageCard component page.
 * This is a wrapper on "MessageCard" component from MUX without adding any custom functionlities
 * @FileName fasatMessageCard.js
 * @FileName fasatMessageCard.stories.js
 * @Author GOUTAM PAL - pgoutam
 * @CreatedOn 06-October-2021
 * @IssueID CDTFASATMOD-324
 */
import React from 'react';
import { Alert, ALERT_SEVERITY, ALERT_VARIANT } from '@manulife/mux';
import './fasatMessageCard.scss';

function FasatMessageCard(props) {
  const { variant, titleText, children, ...rest } = props;

  // Map old MessageCard variants to new Alert props
  const getAlertProps = () => {
    switch (variant) {
      case 'primary_information':
        return { variant: ALERT_VARIANT.PRIMARY, severity: ALERT_SEVERITY.INFO };
      case 'primary_alert':
        return { variant: ALERT_VARIANT.PRIMARY, severity: ALERT_SEVERITY.ALERT };
      case 'primary_warning':
        return { variant: ALERT_VARIANT.PRIMARY, severity: ALERT_SEVERITY.WARNING };
      case 'primary_complete':
        return { variant: ALERT_VARIANT.PRIMARY, severity: ALERT_SEVERITY.COMPLETE };
      case 'secondary_information':
        return { variant: ALERT_VARIANT.SECONDARY, severity: ALERT_SEVERITY.INFO };
      default:
        return { variant: ALERT_VARIANT.PRIMARY, severity: ALERT_SEVERITY.INFO };
    }
  };

  const alertProps = getAlertProps();

  // Accessibility: Use h2 heading when there's content under the title for proper heading hierarchy,
  // otherwise use default (strong) for standalone messages like "No activity records found"
  const titleAs = children ? 'h2' : undefined;

  return (
    <div className="fasatMessageCard">
      <Alert
        {...alertProps}
        title={titleText}
        titleAs={titleAs}
        role="alert"
        aria-atomic="true"
        {...rest}
      >
        {children}
      </Alert>
    </div>
  );
}

export default FasatMessageCard;
